import { connect } from "react-redux";

import TranslatorChat from "./TranslatorChat";
import { post, get } from "../../../../actions/general";

const mapDispatchToProps = {
    post,
    get,
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, mapDispatchToProps)(TranslatorChat);
